import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ExternalLink } from "lucide-react";
import { T } from "@/lib/testIds";

const statusCls = (s) =>
  s === "sent" ? "co-pill co-pill-sent" :
  s === "failed" ? "co-pill co-pill-failed" :
  s === "ready" ? "co-pill co-pill-mock" :
  "co-pill co-pill-mock";

export default function Reminders() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/reminders", { params: { limit: 200 } });
        setLogs(r.data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <header className="co-glass-header sticky top-0 z-20 px-6 lg:px-10 py-5">
        <div className="co-label">Audit</div>
        <h1 className="font-heading text-2xl lg:text-3xl font-bold tracking-tight mt-1">Reminder log</h1>
      </header>

      <div className="p-6 lg:p-10">
        <div className="border co-hairline bg-white overflow-x-auto">
          <table className="co-table">
            <thead>
              <tr>
                <th>Client</th>
                <th>Channel</th>
                <th>Status</th>
                <th>Trigger</th>
                <th>Sent</th>
                <th>Action / Error</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} className="text-center text-[#52525B]">Loading…</td></tr>
              ) : logs.length === 0 ? (
                <tr><td colSpan={6} className="text-center text-[#52525B] py-8">No reminders sent yet.</td></tr>
              ) : (
                logs.map((l) => (
                  <tr key={l.id} data-testid={`reminder-log-${l.id}`}>
                    <td className="font-semibold">{l.client_name}</td>
                    <td className="uppercase text-xs font-bold text-[#52525B]">{l.channel}</td>
                    <td><span className={statusCls(l.status)}>{l.status.toUpperCase()}</span></td>
                    <td className="text-[#52525B] capitalize">{l.trigger}</td>
                    <td className="font-mono text-xs">{new Date(l.sent_at).toLocaleString()}</td>
                    <td>
                      {l.wa_url ? (
                        <a
                          href={l.wa_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid={`${T.openWhatsappBtn}-${l.id}`}
                          className="inline-flex items-center gap-1.5 bg-[#15803D] hover:bg-[#166534] text-white px-3 py-1.5 text-xs font-semibold rounded-sm co-btn-press transition-colors duration-200"
                        >
                          Open WhatsApp <ExternalLink className="h-3 w-3" strokeWidth={2} />
                        </a>
                      ) : (
                        <span className="text-xs text-[#B91C1C] max-w-[280px] truncate inline-block">
                          {l.error || "—"}
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
